export type Props = {
  name: string
}

function ReportsSpreadsheetColumn(_props: Props) {
  return null
}

export default ReportsSpreadsheetColumn
